import axiosInstance from '@/utils/axiosInstance';

// =============================== //
// Goal Service Functions          // 
// =============================== //

export async function getGoals(filters = {}) {
    const { data } = await axiosInstance.get('/goals', { params: filters });
    return data;
}

export async function getGoalById(goalId) {
    const { data } = await axiosInstance.get(`/goals/${goalId}`);
    return data;
}

export async function createGoal(goalData) {
    const { data } = await axiosInstance.post('/goals/create', goalData);
    return data;
}

export async function updateGoal(goalId, updateData) {
    const { data } = await axiosInstance.put(`/goals/${goalId}`, updateData);
    return data;
}

export async function updateGoalProgress(goalId, keyResults) {
    const { data } = await axiosInstance.put(`/goals/${goalId}/progress`, {
        keyResults
    });
    return data;
}

export async function addKeyResult(goalId, keyResultData) {
    const { data } = await axiosInstance.post(`/goals/${goalId}/key-results`, keyResultData);
    return data;
}

export async function deleteKeyResult(goalId, krId) {
    const { data } = await axiosInstance.delete(`/goals/${goalId}/key-results/${krId}`);
    return data;
}

export async function deleteGoal(goalId) {
    const { data } = await axiosInstance.delete(`/goals/${goalId}`);
    return data;
}

export async function sendGoalReminder(goalIds) {
    const { data } = await axiosInstance.post('/goals/reminders', {
        goalIds
    });
    return data;
}